/* @flow */
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';

type Props = {
  full?: boolean,
  children?: any,
};

class DialogBody extends React.Component {
  props: Props;

  render() {
    return (
      <BoxBody full={this.props.full}>
        {this.props.children}
      </BoxBody>
    );
  }
}

export default DialogBody;



// WEBPACK FOOTER //
// ./src/components/DialogBody.jsx